import type { SchoolDetail } from './types';

export const group3: Record<string, SchoolDetail> = {
  'saba-south-africa': {
    slug: 'saba-south-africa',
    lead:
      '南アフリカ・ケープタウンを拠点とする SABA International Butler Academy & Training School。Residential Butler Training（4週間）や Hotel Butler Open Courses（5日間）をはじめ、ホテル・ラグジュアリー・ホスピタリティ向けの複数課程を、南アフリカ・モルディブ・ドバイ・ジンバブエで提供する。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'SABA International Butler Academy & Training School は、南アフリカ・ケープタウンを拠点に、バトラーおよびホスピタリティ分野の訓練を提供する機関です。Residential Butler Training や Hotel Butler 向けオープンコースに加え、客先へのオンサイト研修も行います。',
      },
      {
        heading: '開催地・拠点',
        body: '開催国は南アフリカ、モルディブ、ドバイ、ジンバブエです。Residential Butler Training はケープタウン、Hotel Butler Open Courses の開催予定にはモルディブが含まれます。',
        table: [
          { label: '開催国', value: '南アフリカ、モルディブ、ドバイ、ジンバブエ' },
          { label: 'Residential Butler Training', value: 'ケープタウン' },
          { label: 'Hotel Butler Open Courses（開催予定）', value: 'モルディブ' },
        ],
      },
      {
        heading: '沿革と創設者',
        body: '設立年および創設者について、公式サイトに記載はありません。',
        note: '設立年・創設者は公式サイトに記載なし',
      },
      {
        heading: '提供している課程',
        body: '公式が示す主な課程は次のとおりです。Residential Butler Training と Hotel Butler Open Courses には開催予定日が示されています。',
        bullets: [
          'Residential Butler Training（4週間・ケープタウン・SABA認定）— 開催予定 2027年1月18日〜29日',
          'Hotel Butler Training – Open Courses（5日間の国際オープンコース・SABA Hotel Butler 認定）— 開催予定 2027年1月10日〜14日（モルディブ）',
          'Hotel Butler Training（ホテル向け）',
          'Luxury Mindset Training（ゲスト期待値・サービス意識・自信形成）',
          'Hospitality Training（ハウスキーピング・料飲・フロント部門）',
          '客先オンサイト研修（クライアント先へ出張）',
        ],
      },
      {
        heading: '課程の詳細',
        body: '各課程の内容・期間・認定について、公式に示されている範囲は次のとおりです。',
        table: [
          {
            label: 'Residential Butler Training',
            value: '4週間・ケープタウン・SABA認定／開催予定 2027年1月18日〜29日',
          },
          {
            label: 'Hotel Butler Open Courses',
            value: '5日間・SABA Hotel Butler 認定／開催予定 2027年1月10日〜14日（モルディブ）',
          },
          {
            label: 'Hotel Butler Training',
            value: 'ホテル向け',
          },
          {
            label: 'Luxury Mindset Training',
            value: 'ゲスト期待値・サービス意識・自信形成',
          },
          {
            label: 'Hospitality Training',
            value: 'ハウスキーピング・料飲・フロント部門',
          },
          {
            label: '客先オンサイト研修',
            value: 'クライアント先へ出張して実施',
          },
        ],
      },
      {
        heading: '教授法・学び方',
        body: '教授法として、実技訓練、ロールプレイ、実際のサービス場面を通じて、自信・サービス意識・ゲスト視点を養うと公式に示されています。',
        bullets: [
          '実技訓練',
          'ロールプレイ',
          '実際のサービス場面',
          '自信・サービス意識・ゲスト視点を養う',
        ],
      },
      {
        heading: '顧客・受講対象',
        body: '公式が示す顧客・対象は次の9種です。',
        bullets: [
          'ホテル',
          'リゾート',
          'ロッジ',
          'クルーズ客船',
          '法人',
          '航空チーム',
          'ヨットチーム',
          '個人',
          'レジデンシャルバトラー志望者',
        ],
      },
      {
        heading: '学費と支払条件',
        body: '学費および支払条件について、公式サイトに記載はありません。為替換算は行いません。',
        note: '学費・支払条件は公式サイトに記載なし',
      },
      {
        heading: '定員と受講対象',
        body: '顧客・対象としてホテル、リゾート、ロッジ、クルーズ客船、法人、航空チーム、ヨットチーム、個人、レジデンシャルバトラー志望者が挙げられています。定員の具体数は公式に明記されていません。',
        note: '定員の具体数は公式サイトに記載なし',
      },
      {
        heading: '応募資格と申込方法',
        body: '応募資格の詳細は公式に記載がありません。連絡先は次のとおりです。',
        table: [
          { label: 'メール', value: 'info@butleracademy.co.za' },
          { label: '電話', value: '+27 (0)61 631 2878' },
        ],
        note: '応募資格・申込手順の詳細は公式サイトに記載なし',
      },
      {
        heading: '宿泊と食事',
        body: '宿泊および食事の条件について、公式サイトに記載はありません。',
        note: '宿泊・食事は公式サイトに記載なし',
      },
      {
        heading: '言語',
        body: '使用言語について、公式サイトに記載はありません。',
        note: '使用言語は公式サイトに記載なし',
      },
      {
        heading: '認定・受賞',
        body: 'Residential Butler Training は SABA認定、Hotel Butler Open Courses は SABA Hotel Butler 認定と示されています。その他の受賞歴等は公式に記載がありません。',
        bullets: [
          'Residential Butler Training: SABA認定',
          'Hotel Butler Open Courses: SABA Hotel Butler 認定',
        ],
      },
      {
        heading: '連絡先',
        body: '公式の連絡先は次のとおりです。',
        table: [
          { label: '公式サイト', value: 'https://www.thebutlerschool.com/' },
          { label: 'メール', value: 'info@butleracademy.co.za' },
          { label: '電話', value: '+27 (0)61 631 2878' },
        ],
      },
      {
        heading: '修了後の進路と就職支援',
        note: '公式サイトに記載なし',
      },
    ],
    sources: [
      { label: 'SABA International Butler Academy 公式', url: 'https://www.thebutlerschool.com/' },
    ],
  },

  'butler-academy-paris': {
    slug: 'butler-academy-paris',
    lead:
      'フランス・パリおよびサン＝クラウドに拠点を置く Butler Academy。英語・フランス語・イタリア語・ポルトガル語・中国語の5言語で研修と認定を提供し、WSET認定センターや Qualiopi 認証、フランス職業資格（RNCP/RS）を持つ。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'Butler Academy（パリ）は、フランスでバトラーおよびホスピタリティ関連の研修・認定を提供する機関です。Excellence de Service をはじめ、専門職・ワイン・マネジメント・ケータリングなどの研修カテゴリを持ち、テーブルウェア、フラワーアート、リネン管理なども扱います。',
      },
      {
        heading: '開催地・拠点',
        body: '所在地として次の2つが記載されています。',
        table: [
          { label: '所在地（パリ）', value: '28 rue de Chambéry 75015 Paris' },
          {
            label: '所在地（サン＝クラウド）',
            value: 'Bureaux de la Colline – 1 Rue Royale 92210 Saint-Cloud',
          },
        ],
      },
      {
        heading: '沿革と創設者',
        body: '設立年および創設者について、公式サイトに記載はありません。',
        note: '設立年・創設者は公式サイトに記載なし',
      },
      {
        heading: '提供している課程',
        body: '研修カテゴリとして次が示されています。課程の期間・料金は公式に記載がありません。',
        bullets: [
          'Excellence de Service',
          '専門職（メートル・ドテル、ヘッドウェイター、ケータリング）',
          'ワイン・醸造学',
          'マネジメント',
          'ケータリング',
          'テーブルウェア',
          'フラワーアート',
          'リネン管理',
        ],
        note: '課程期間・料金は公式サイトに記載なし',
      },
      {
        heading: '研修カテゴリの内訳',
        body: '公式が示す研修の柱は、次の5カテゴリに加え、テーブルウェア・フラワーアート・リネン管理です。',
        table: [
          { label: 'Excellence de Service', value: 'サービス卓越性に関する研修' },
          {
            label: '専門職',
            value: 'メートル・ドテル、ヘッドウェイター、ケータリング',
          },
          { label: 'ワイン・醸造学', value: 'ワインおよび醸造学に関する研修' },
          { label: 'マネジメント', value: 'マネジメントに関する研修' },
          { label: 'ケータリング', value: 'ケータリングに関する研修' },
          { label: 'その他', value: 'テーブルウェア、フラワーアート、リネン管理' },
        ],
      },
      {
        heading: '学費と支払条件',
        body: '課程期間および料金について、公式サイトに記載はありません。為替換算は行いません。',
        note: '課程期間・料金は公式サイトに記載なし',
      },
      {
        heading: '定員と受講対象',
        body: '定員について、公式には「個別指導を重視するため最大10名」との記載があります。別ページには「4〜15名」の記載もあります。両方の記載があるため、定員数は断定しません。',
        bullets: [
          '「最大10名」（個別指導を重視するため）との記載',
          '別ページには「4〜15名」との記載もあり',
        ],
        note: '定員は「最大10名」と「4〜15名」の両記載があるため断定しない',
      },
      {
        heading: '応募資格と申込方法',
        note: '応募資格・申込方法の詳細は公式サイトに記載なし',
      },
      {
        heading: '宿泊と食事',
        note: '宿泊・食事は公式サイトに記載なし',
      },
      {
        heading: '言語',
        body: '研修と認定を次の5言語で提供します。',
        bullets: ['英語', 'フランス語', 'イタリア語', 'ポルトガル語', '中国語'],
      },
      {
        heading: '認定・受賞',
        body: '公式が示す認定・認証は次のとおりです。',
        bullets: [
          'WSET®（Wine & Spirit Education Trust）レベル1・2・3 の認定センター',
          'Qualiopi 認証（training action 区分）',
          'フランス職業資格 RNCP37860（Server in Catering）',
          'フランス職業資格 RNCP39224（Head Waiter）',
          'フランス職業資格 RS7105（Managing Client Relations in Luxury）',
        ],
        table: [
          {
            label: 'WSET',
            value: 'レベル1・2・3 の認定センター',
          },
          {
            label: 'Qualiopi',
            value: '認証（training action 区分）',
          },
          {
            label: 'RNCP37860',
            value: 'Server in Catering',
          },
          {
            label: 'RNCP39224',
            value: 'Head Waiter',
          },
          {
            label: 'RS7105',
            value: 'Managing Client Relations in Luxury',
          },
        ],
      },
      {
        heading: '修了後の進路と就職支援',
        note: '公式サイトに記載なし',
      },
    ],
    sources: [
      { label: 'Butler Academy（パリ）公式', url: 'https://butler-academy.com/en/' },
    ],
  },

  'british-butler-institute': {
    slug: 'british-butler-institute',
    lead:
      'The British Butler Institute は、ロンドンでの4週間コース（3つのマスタークラスを含む）を提供し、ドバイでは客船 Queen Elizabeth 2（QE2）デッキ1に拠点を置く。創設者 Gary Williams 氏は複数の王室家庭の元執事とされる（検索時点の公開情報・公式未確認）。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'The British Butler Institute は、英国でバトラー訓練を提供し、ドバイにも拠点を持つ機関です。ロンドンでの4週間コースに加え、ドバイでは客船 QE2 船内で完結する没入型研修を行います。',
      },
      {
        heading: '沿革と創設者',
        body: '創設者は Gary Williams 氏です。複数の王室家庭の元執事であり、Principal として訓練チームを統括します（検索時点の公開情報・公式未確認）。設立は20年以上前とされます（検索時点の公開情報・公式本文は取得できず）。',
        bullets: [
          '創設者: Gary Williams 氏（検索時点の公開情報・公式未確認）',
          '複数の王室家庭の元執事（検索時点の公開情報・公式未確認）',
          'Principal として訓練チームを統括（検索時点の公開情報・公式未確認）',
          '設立: 20年以上前（検索時点の公開情報・公式本文は取得できず）',
        ],
        note: '設立年の確定値および創設者情報の公式本文は取得できず。上記は検索時点の公開情報・公式未確認',
      },
      {
        heading: '開催地・拠点',
        body: 'ロンドンでの課程に加え、ドバイでは客船 Queen Elizabeth 2（QE2）のデッキ1に拠点を開設しています。ドバイ拠点では船内で完結する没入型研修を行います。',
        table: [
          { label: 'ロンドン', value: '4週間コースを開催（非宿泊型）' },
          {
            label: 'ドバイ',
            value: '客船 Queen Elizabeth 2（QE2）のデッキ1に拠点／船内完結の没入型研修',
          },
        ],
      },
      {
        heading: '提供している課程',
        body: 'ロンドンでの4週間コース（3つのマスタークラスを含む）が示されています。ドバイ拠点では船内で完結する没入型研修を提供します。',
        bullets: [
          'ロンドン: 4週間コース（3つのマスタークラスを含む）',
          'ドバイ: 客船 QE2 船内で完結する没入型研修',
        ],
      },
      {
        heading: '学費と支払条件',
        body: '料金は英ポンド建てです。予約時に50%の申込金、残額は開講の1か月前までに全額という支払条件が示されています（検索時点の公開情報）。具体的な受講料の金額は、公式ページの本文を取得できず未確認です。為替換算は行いません。',
        table: [
          { label: '通貨', value: '英ポンド建て（検索時点の公開情報）' },
          { label: '申込金', value: '予約時に50%（検索時点の公開情報）' },
          { label: '残額', value: '開講の1か月前までに全額（検索時点の公開情報）' },
          { label: '具体的な受講料金額', value: '未確認（公式ページ本文を取得できず）' },
        ],
        note: '具体的な受講料の金額は公式ページ本文を取得できず未確認。支払条件は検索時点の公開情報・公式未確認',
      },
      {
        heading: '定員と受講対象',
        note: '定員・受講対象の詳細は公式サイトに記載なし',
      },
      {
        heading: '応募資格と申込方法',
        body: '支払条件として、予約時に50%の申込金、残額は開講1か月前までの全額納付が示されています（検索時点の公開情報）。応募資格の詳細は公式に確認できていません。',
        note: '応募資格の詳細は公式サイトに記載なし。支払条件は検索時点の公開情報',
      },
      {
        heading: '宿泊と食事',
        body: 'コースは非宿泊型です。ただし、ロンドンおよび近郊での宿泊先探しを予算に応じて支援します。食事に関する条件の詳細は公式に確認できていません。',
        bullets: [
          '非宿泊型コース',
          'ロンドンおよび近郊での宿泊先探しを予算に応じて支援',
        ],
        note: '食事の条件は公式サイトに記載なし',
      },
      {
        heading: 'ドバイ拠点（QE2）',
        body: 'ドバイでは、客船 Queen Elizabeth 2（QE2）のデッキ1に拠点を開設しています。船内で完結する没入型研修を行います。',
        table: [
          { label: '拠点', value: '客船 Queen Elizabeth 2（QE2）デッキ1' },
          { label: '形態', value: '船内で完結する没入型研修' },
        ],
      },
      {
        heading: '言語',
        note: '使用言語は公式サイトに記載なし',
      },
      {
        heading: '認定・受賞',
        note: '公式サイトに記載なし',
      },
      {
        heading: '修了後の進路と就職支援',
        note: '公式サイトに記載なし',
      },
    ],
    sources: [
      {
        label: 'The British Butler Institute 公式（Butler School）',
        url: 'https://www.britishbutlerinstitute.com/butler-school/',
      },
      {
        label: 'The British Butler Institute（Fees & Applications）',
        url: 'https://www.britishbutlerinstitute.com/butler-school/fees-applications/',
      },
    ],
  },
};
